import { FC, ReactNode, useRef, useEffect, useState } from 'react';
import {
    Button,
    Form,
    Input,
    Row,
    Col,
    Select,
    DatePicker,
    InputNumber,
    TimePicker,
    notification,
    Tooltip,
    Modal,
    message,
    FormInstance
} from 'antd';
import './style.scss';
import { formSchemaData, schemaType } from './data';
import { MEDIA } from '../enum';
import moment from 'moment';
import { intersection } from 'lodash-es';
import locale from 'antd/es/date-picker/locale/zh_CN';
import ProveList from '../proveList';
import { uploadReviewApi, saveApi, uploadApi } from '../../api';
import { createPdf, passWordFiled, utf8_to_b64, b64_to_utf8 } from '../../utils';

const FormPlugin: FC<any> = ({
    next = () => {},
    data = {},
    onChange = () => {},
    options = [],
    nextParam
}) => {
    const $form = useRef<FormInstance>(null);
    const [open, setOpen] = useState(false);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);

    function handleCancel() {
        setOpen(false);
    }

    useEffect(() => {
        if (!$form.current || !data) return;

        const formValues = {
            ...data,
            validDate: data?.startValidDate && data?.endValidDate 
                ? [
                    data.startValidDate ? moment(data.startValidDate, 'YYYY-MM-DD') : null,
                    data.endValidDate ? moment(data.endValidDate, 'YYYY-MM-DD') : null
                  ]
                : undefined,
            receptionTime: data?.receptionTime
                ? Array.isArray(data.receptionTime)
                    ? data.receptionTime.map((item: moment.MomentInput) => item ? moment(item, 'HH:mm') : null)
                    : undefined
                : undefined,
        };

        // 清理 undefined 值
        Object.keys(formValues).forEach(key => {
            if (formValues[key] === undefined) {
                delete formValues[key];
            }
        });

        $form.current.setFieldsValue(formValues);
    }, [data]);

    async function nextClick() {
        setOpen(true);
    }

    async function examination() {
        try {
            const formValues = await ($form.current as FormInstance)?.validateFields();
            const appData = {
                ...data,
                ...formValues
            };

            // 处理接待时间格式
            let formattedReceptionTime: string[] = [];
            if (Array.isArray(appData.receptionTime)) {
                formattedReceptionTime = appData.receptionTime.map((time: moment.MomentInput) => {
                    if (moment.isMoment(time)) {
                        return time.format('HH:mm');
                    }
                    return typeof time === 'string' ? time : '';
                }).filter(Boolean);
            } else if (typeof appData.receptionTime === 'string') {
                formattedReceptionTime = appData.receptionTime.split(',');
            }

            const formattedData = {
                ...appData,
                applicantIdCard: appData.applicantIdCard,
                orgName: appData.orgName,
                department: appData.department,
                registerBn: appData.registerBn,
                legalPerson: appData.legalPerson,
                principal: appData.principal,
                idCard: appData.idCard,
                phone: appData.phone,
                zipCode: appData.zipCode || null,
                startValidDate: appData.startValidDate || appData.validDate?.[0]?.format('YYYY-MM-DD'),
                endValidDate: appData.endValidDate || appData.validDate?.[1]?.format('YYYY-MM-DD'),
                address: appData.address,
                ownership: appData.ownership,
                category: appData.category_wj || appData.category,
                subject: appData.subject,
                bed: appData.bed,
                // 始终保持数组格式
                receptionTime: formattedReceptionTime,
                media: appData.media,
                adDuration: appData.adDuration || null,
                publish: appData.publish || null,
                other: appData.other || null,
                contactName: appData.contactName,
                contactIdCard: appData.contactIdCard,
                contactPhone: appData.contactPhone,
                contactEmail: appData.contactEmail,
                area: appData.area,
                orgProperty: appData.orgProperty,
                categoryName: appData.categoryName || null,
                mediaName: appData.mediaName || null,
                areaName: appData.areaName || null,
                orgPropertyName: appData.orgPropertyName || null,
                uniformCreditCode: appData.uniformCreditCode
            };

            // 用于提交的参数
            const params = {
                ...passWordFiled(formSchemaData, formattedData),
                id: nextParam.id,
                media: formattedData.media?.toString() || '',
                // 提交时使用逗号分隔的字符串
                receptionTime: formattedReceptionTime.join(','),
                applicantIdCard: utf8_to_b64(formattedData.applicantIdCard),
                channel: '2'
            };

            const { code, data: result = [], message: msg } = await saveApi(params);
            if (code !== 200) {
                message.error(`${msg}！`);
                return null;
            }

            // 返回给预览组件的数据，确保 receptionTime 保持数组格式
            return { 
                appData: formattedData,
                result 
            };
        } catch (error) {
            setOpen(false);
            notification.error({ message: '必填信息不能为空；请补全信息！' });
            return null;
        }
    }

    async function submit() {
        setLoading2(true);
        const resultData = await examination();
        if (!resultData) return setLoading2(false);
        // const { appData } = resultData;
        try {
            // 医疗广告审查证明
            // const prove = await createPdf(
            //     <ProveList data={appData} options={options} />,
            //     '医疗广告审查证明'
            // );
            // const { data: files, code: uploadCode } = await uploadApi(prove);
            // const { code } = await uploadReviewApi({ file: files[0], id: nextParam.id });
            setLoading2(false);
            // if (code !== 200 || uploadCode !== 200)
            //     return notification.error({ message: '医疗广告审查证明；上传失败！' });
            next(5);
        } catch (error) {
            setLoading2(false);
            // notification.error({ message: '医疗广告审查证明；生成失败！' });
        }
    }

    async function Prequalification() {
        setLoading1(true);
        const resultData = await examination();
        if (!resultData) return setLoading1(false);
        // const { appData } = resultData;
        try {
            // 医疗广告审查证明
            // const prove = await createPdf(
            //     <ProveList data={appData} options={options} />,
            //     '医疗广告审查证明'
            // );
            // const { data: files, code: uploadCode } = await uploadApi(prove);
            // const { code } = await uploadReviewApi({ file: files[0], id: nextParam.id });
            // setLoading1(false);
            // if (code !== 200 || uploadCode !== 200)
            //     return notification.error({ message: '医疗广告审查证明；上传失败！' });

            next(3, 'applicationData', resultData);
        } catch (error) {
            setLoading1(false);
            notification.error({ message: '医疗广告审查证明；生成失败！' });
        }
    }

    function getrules(item: any) {
        const rules = typeof item.rules === 'function' ? item.rules(data || {}) : item.rules;
        if (rules.length === 2) {
            const newRules = [];
            newRules.push({ ...rules[0] });
            newRules.push(({ getFieldValue }: any) => ({
                validator() {
                    const val = getFieldValue(item.filed);
                    if (!val || rules[1].pattern.test(val)) return Promise.resolve();
                    return Promise.reject(new Error(rules[1].message));
                }
            }));
            return newRules;
        }
        return rules;
    }
     // 监听字段变化
  const handleValuesChange = (changedValues: any, allValues: any) => {
  
    if ('registerBn' in changedValues) {
      const registerBn = changedValues.registerBn;
      
      // 如果是清空操作
      if (!registerBn) {
        // 统一处理清空逻辑
        const clearFields = async () => {
          // 1. 清空表单字段
          await $form.current?.setFields([
            {
              name: 'category_wj',
              value: undefined,
              errors: []
            },
            {
              name: 'registerBn',
              value: undefined,
              errors: []
            }
          ]);
  
          // 2. 从本地数据中删除相关字段
          if (data) {
            delete data.category_wj;
            delete data.registerBn;
          }
  
          // 3. 通知父组件更新
          onChange('category_wj', undefined);
          onChange('registerBn', undefined);
  
        };
  
        clearFields();
        return;
      }
  
      // 2. 提取倒数5位到倒数2位，然后加上X
      const lastFourPlusX = registerBn.slice(-5, -1) + 'X';
     
      
      // 3. 验证后5位是否符合要求
      if (lastFourPlusX.length === 5) {
        // 获取医疗机构类别选项
        const categoryOptions = getCategoryOptions(options);
      
        
        // 查找匹配的类别
        const matched = categoryOptions.find((opt: { value: string; }) => opt.value === lastFourPlusX);
       
        
        if (matched) {
       
  
          // 1. 使用 Form 实例方法设置值
          $form.current?.setFieldsValue({ 
            category_wj: matched.value 
          });
  
  
          // 2. 确保使用正确的回调更新父组件状态
          onChange('category_wj', matched.value);
  
          // 3. 可以尝试延迟设置以确保 DOM 已更新
          setTimeout(() => {
            ($form.current as FormInstance)?.setFieldsValue({ 
              category_wj: matched.value 
            });
          }, 0);
  
        //   message.success('已自动匹配医疗机构类别');
        } else {
             // 未匹配时清空 category_wj 字段
             const clearCategory = async () => {
                // 1. 清空表单字段
                await $form.current?.setFields([{
                    name: 'category_wj',
                    value: undefined,
                    errors: []
                }]);
    
                // 2. 从本地数据中删除字段
                if (data) {
                    delete data.category_wj;
                }
    
                // 3. 通知父组件更新
                onChange('category_wj', undefined);
    
            
            };
    
            clearCategory();
        }
      }
    }
  
    // 修改同步逻辑，过滤掉 undefined 值
    Object.entries(changedValues).forEach(([key, value]) => {
        if (value === undefined) {
            delete data[key];
        } else {
            data[key] = value;
        }
    });
  };
  // 工具函数：获取动态生成的 category_wj 选项
const getCategoryOptions = (globalOptions: any[]) => {
    // 从 formSchemaData 中获取配置
    const categoryConfig = formSchemaData
      .flatMap(section => section.schema)
      .find(item => item.filed === 'category_wj');
  
    if (typeof categoryConfig?.props !== 'object' || !categoryConfig?.props?.options) return [];
    
    // 执行动态选项生成逻辑
    const generator = categoryConfig.props.options;
    return typeof generator === 'function' 
      ? generator(globalOptions) 
      : generator;
  };

    return (
        <div className='form-box'>
            <div className='text-title'>
                <span className='line'></span>
                <span>表单填写</span>
            </div>
            <div className='text-title-line'></div>

            <Form
                name='basic'
                labelCol={{ span: 8 }}
                wrapperCol={{ flex: 1 }}
                autoComplete='off'
                onValuesChange={handleValuesChange} // 关键监听器
                ref={$form}
            >
                {formSchemaData.map(({ title, schema }, index: number) => (
                    <div className='from-box' key={index}>
                        <div className='title'>
                            {title}
                            {index === 0 ? (
                                <span
                                    style={{
                                        paddingLeft: '40px',
                                        color: 'red',
                                        fontWeight: 'normal',
                                        fontSize: '18px'
                                    }}
                                >
                                    注：参照医疗机构执业许可证或者备案证填写以下信息，不是营业执照！
                                </span>
                            ) : null}
                        </div>
                        <Row>
                            {schema.map((item) => (
                                <Col span={item.span || 12} key={item.filed}>
                                    {item.filed === 'media' &&
                                    intersection(MEDIA, !!data ? data[item.filed] ?? [] : [])
                                        .length ? (
                                        <div
                                            style={{
                                                width: '100%',
                                                textAlign: 'right',
                                                color: 'red',
                                                fontSize: '16px',
                                                top: '-32px',
                                                position: 'absolute'
                                            }}
                                        >
                                            请将视频和音频发送至邮箱swjwylgg2023@163.com
                                        </div>
                                    ) : null}
                                    <Tooltip
                                        title={
                                            typeof item.tipsText === 'function'
                                                ? item.tipsText(data, options)
                                                : item.tipsText
                                        }
                                        placement='top'
                                        color='#0094fe'
                                        key={item.filed}
                                    >
                                        <Form.Item
                                            className={item.className}
                                            label={item.label}
                                            labelCol={item.labelCol}
                                            name={item.filed}
                                            hidden={!!item.showFiled}
                                            rules={
                                                typeof item.rules === 'function'
                                                    ? item.rules(data, options)
                                                    : item.rules
                                            }
                                        >
                                            {fromItem(item, data || {}, onChange, options, $form)}
                                        </Form.Item>
                                        {!!item.showFiled ? (
                                            <Form.Item
                                                dependencies={[item.filed]}
                                                label={item.label}
                                                name={item.showFiled}
                                                rules={getrules(item)}
                                                validateTrigger={['onChange', 'onBlur']}
                                            >
                                                <Input
                                                    {...(item.props || {})}
                                                    allowClear
                                                    onChange={(e: any) => {
                                                        onChange(null, {
                                                            [item.filed]: e.target.value,
                                                            [(item as any).showFiled]:
                                                                e.target.value
                                                        });
                                                    }}
                                                />
                                            </Form.Item>
                                        ) : null}
                                    </Tooltip>
                                </Col>
                            ))}
                        </Row>
                    </div>
                ))}
            </Form>

            <div>
                <Button
                    onClick={next.bind(null, 1)}
                    type='primary'
                    style={{ width: 140, marginTop: 15, height: 35, marginRight: 15 }}
                >
                    上一步
                </Button>
                <Button
                    // onClick={nextClick}
                    onClick={Prequalification}
                    loading={loading1}
                    type='primary'
                    style={{ width: 140, marginTop: 15, height: 35 }}
                >
                    下一步
                </Button>
            </div>

            <Modal
                title={null}
                open={open}
                footer={null}
                onCancel={handleCancel}
                destroyOnClose={true}
                width={500}
                style={{ textAlign: 'center', top: '35%' }}
            >
                {/* <div style={{ fontSize: '12px', opacity: 0, fontWeight: 'bold' }}>
                    进行 "智能预审" 可以提高审核的准确率
                </div> */}
                <Button
                    type='primary'
                    ghost
                    onClick={Prequalification}
                    loading={loading1}
                    style={{ width: '400px', marginTop: '15px', textAlign: 'left' }}
                >
                    1、进行智能预审，自动生成表格
                </Button>
                <Button
                    type='primary'
                    onClick={submit}
                    ghost
                    loading={loading2}
                    style={{ width: '400px', marginTop: '15px', textAlign: 'left' }}
                >
                    2、已下载表格，并完成盖章，由此上传
                </Button>
            </Modal>
        </div>
    );
};

function fromItem(
    item: schemaType,
    data: Record<string, any> = {},
    onChange: (e: string, val: any) => {},
    options: any[],
    form: React.RefObject<FormInstance>
): ReactNode | null {
    let { type, props = {}, filed } = item;
    if (typeof props === 'function')
        props = (props as (item: any, options?: any[]) => Record<string, unknown>)(data, options);

    switch (type) {
        case 'input-registerBn':
            return (
                <Input 
      {...props} 
      allowClear 
      onChange={(e) => {
        onChange(filed, e.target.value);
      }}
    />
            );
        case 'input':
            return (
                <Input {...props} allowClear onBlur={(e: any) => onChange(filed, e.target.value)} />
            );
        case 'number':
            return (
                <InputNumber
                    style={{ width: '100%' }}
                    min={0}
                    max={99999}
                    {...props}
                    onBlur={(e: any) => {
                        let val = e.target.value * 1;
                        onChange(filed, isNaN(val) ? 0 : val);
                    }}
                />
            );
        case 'select':
            return (
                <Select
                    {...props}
                    options={
                        typeof props.options === 'function' ? props.options(options) : props.options
                    }
                    onChange={(value: any) => onChange(filed, value)}
                />
            );
            case 'select-search':
                return (
                    <Select
                    {...props}
                    showSearch={true}
                    value={data[filed]}  // 添加 value 属性
                    // 根据 label 字段进行搜索（需类型断言）
                    filterOption={(input: string, option: any) => 
                      (option?.label as string)?.toLowerCase().includes(input.toLowerCase())
                    }
                    options={
                      typeof props.options === 'function' 
                        ? props.options(options)  // 执行动态过滤逻辑
                        : props.options
                    }
                    onChange={(value: string) => {
                        // 同步到所有数据源
                        data[filed] = value; // 更新本地数据
                        onChange(filed, value); // 更新父组件
                       
                      }}
                    // 显示格式优化
                    optionFilterProp="label"       // 显式声明按 label 过滤
                    className="my-select-search"
                    // 其他优化属性
                    allowClear                     // 允许清空选择
                    placeholder="请搜索或选择"      // 自定义占位符
                  />
            );
        case 'text':
            return (
                <Input.TextArea
                    {...props}
                    onChange={({ target }: any) => onChange(filed, target.value)}
                />
            );
        case 'date':
            return (
                <DatePicker
                    {...props}
                    locale={locale}
                    format='YYYY-MM-DD'
                    onChange={(moment) => onChange(filed, moment?.format('YYYY-MM-DD'))}
                />
            );
        case 'range':
            return (
                <DatePicker.RangePicker
                    {...props}
                    locale={locale}
                    format='YYYY-MM-DD'
                    onChange={(moments) => {
                        const [startValidDate, endValidDate] = moments?.map((moment) =>
                            moment?.format('YYYY-MM-DD')
                        ) || ['', ''];
                        onChange('', { startValidDate, endValidDate });
                    }}
                />
            );
        case 'time':
            return (
                <TimePicker.RangePicker
                    {...props}
                    locale={locale}
                    onChange={(moments) => {
                        const [startTime, endTime] =
                            moments?.map((moment) => moment?.format('HH:mm')) || [];
                        onChange(filed, [startTime, endTime]);
                    }}
                />
            );
        case 'custom':
            return <span>{item.render ? item.render(data, options) : ''}</span>;
    }
    return null;
}

export default FormPlugin;
